import * as React from 'react';

const logo = require('./img/logo.svg');

export default function () {
  return (
    <img src={logo} className="sidePane-logo" />
  );
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/SidePanel/Logo.tsx